exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#rows[data-v-aa92c680]{\n  color: black;\n}\n", ""]);

// exports
